import { FlexColAlignCenterBoth } from 'components/primitives/flex';
import styled from 'styled-components';
import { ButtonVariant } from './types';

export interface BookingActionButtonProps {
  ctaText?: string;
  userType: ButtonVariant;
  subText?: string;
  justText?: boolean;
  onSubmitAvailable?: boolean;
  onSubmit: () => void;
}

const BookingActionButton = ({
  ctaText = 'Approve',
  userType = 'captain',
  onSubmit,
  subText,
  onSubmitAvailable = true,
  justText = false,
}: BookingActionButtonProps) => (
  <>
    {onSubmitAvailable && (
      <CTAButton
        onClick={onSubmit}
        className={`
            ${userType === 'captain' ? 'bookingActionButtonCaptain' : ''}
            ${userType === 'renter' ? 'bookingActionButtonRenter' : ''}
            ${userType === 'owner' || userType === 'boat manager' ? 'bookingActionButtonYellow' : ''}
            ${userType === 'captain_outline' ? 'bookingActionButtonCaptainOutline' : ''}
            ${userType === 'renter_outline' ? 'bookingActionRenterOutline' : ''}
            ${userType === 'owner_outline' ? 'bookingActionOwnerOutline' : ''}
            ${justText ? 'justText' : ''}
          `}
      >
        {ctaText}
      </CTAButton>
    )}
    {subText && <SubText as="p">{subText}</SubText>}
  </>
);

export default BookingActionButton;

const CTAButton = styled.button.attrs({ type: 'button' })`
  background: white;
  border: 1px solid white;
  width: 100%;
  text-align: center;
  padding: 0 18px;
  font-size: 14px;
  line-height: 18px;
  text-transform: uppercase;
  color: white;
  border-radius: 8px;
  font-weight: bold;
  height: 55px;

  &.bookingActionButtonCaptain {
    background: #00a2ad;
    border: 1px solid #00a2ad;
    &:hover {
      background: #00677d;
      border: 1px solid #00677d;
    }
    &:active {
      background: #00677d;
      border: 1px solid #00677d;
    }
  }

  &.bookingActionButtonRenter {
    background: #0751c2;
    border: 1px solid #0751c2;
    &:hover {
      background: #0a4195;
      border: 1px solid #0a4195;
    }
    &:active {
      background: #083170;
      border: 1px solid #083170;
    }
  }

  &.bookingActionButtonYellow {
    background: #f4c064;
    border: 1px solid #f4c064;
    color: #17233c;
    &:hover {
      background: #e7a433;
      border: 1px solid #e7a433;
    }
    &:active {
      background: #d28d19;
      border: 1px solid #d28d19;
    }
  }

  &.bookingActionButtonCaptainOutline {
    background: transparent;
    border: 1px solid #00677d;
    color: #00677d;
    &:hover {
      border: 1px solid #00677d;
      color: #00677d;
    }
    &:active {
      border: 1px solid #00677d;
    }
  }

  &.bookingActionRenterOutline {
    background: transparent;
    border: 1px solid #0751c2ff;
    color: #0751c2ff;
    &:hover {
      background: #0751c2ff;
      color: white;
    }
    &:active {
      background: #083170;
      border: 1px solid #083170;
    }
  }

  &.bookingActionOwnerOutline {
    background: transparent;
    border: 1px solid #0e7873;
    color: #0e7873;
    &:hover {
      background: #0c605c;
      border: 1px solid #0c605c;
      color: white;
    }
    &:active {
      background: #154353;
      border: 1px solid #154353;
    }
  }

  &.justText {
    border: none !important;
    text-transform: initial !important;
    font-weight: normal !important;

    &:hover {
      background: unset !important;
      color: inherit !important;
    }
  }
`;

const SubText = styled(FlexColAlignCenterBoth)`
  width: '100%';
`;
